import { motion } from "framer-motion";
import { Reveal } from "./Reveal";

const partners = ["Ferrari", "Ducati", "Maserati", "OMR", "GD", "FCA Stellantis"];

export const Brands = () => (
  <section id="collaborazioni" data-testid="brands" className="border-t border-white/10 bg-black">
    <div className="max-w-[1600px] mx-auto px-6 md:px-12 py-24 md:py-32">
      <Reveal>
        <div className="flex items-center gap-3 mb-6">
          <span className="w-8 h-px bg-red-600" />
          <span className="font-mono text-xs uppercase tracking-[0.3em] text-red-600">Partner & Clienti</span>
        </div>
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 items-end mb-16">
          <h2 className="font-display font-black uppercase text-4xl md:text-6xl tracking-tighter leading-none">
            Partner di<br /><span className="text-red-600">eccellenza</span>
          </h2>
          <p className="max-w-md text-zinc-400 leading-relaxed lg:pb-2">
            Fornitore ufficiale <span className="text-white font-medium">Ducati</span>, collaboriamo con i grandi
            nomi dell'automotive e dell'industria al cuore della Motor Valley emiliana, dove la fiducia si
            costruisce sulla precisione.
          </p>
        </div>
      </Reveal>

      <div className="grid grid-cols-2 md:grid-cols-3 border-t border-l border-white/10">
        {partners.map((p, i) => (
          <Reveal key={p} delay={i * 0.07}>
            <motion.div
              whileHover={{ backgroundColor: "rgba(255,255,255,0.03)" }}
              data-testid={`partner-${p.replace(/\s/g, "-").toLowerCase()}`}
              className="group flex items-center justify-center h-32 md:h-44 border-b border-r border-white/10"
            >
              <span className="font-display font-black uppercase text-2xl md:text-4xl tracking-tight text-zinc-600 group-hover:text-white transition-colors duration-400">
                {p}
              </span>
            </motion.div>
          </Reveal>
        ))}
      </div>

      <Reveal delay={0.2}>
        <p className="mt-8 font-mono text-[11px] uppercase tracking-wider text-zinc-600">
          Certificazioni: ISO 9001 · CE · TÜV Italia
        </p>
      </Reveal>
    </div>
  </section>
);
